import axios from 'axios'
import store from '../store'
import { vm } from '../main'
const serverIp = 'll-livespeaking.liveabc.com/'
const appPath = 'api'
export const apiPath = 'https://' + serverIp + appPath
const api = axios.create({
  baseURL: apiPath,
  timeout: 60000,
  headers: {
    'access-control-allow-origin': '*',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

api.interceptors.request.use(function (config) {
  const token = store.state.auth.user ? store.state.auth.user.token : null

  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  } else {
    console.error('Token not found')
    // Optionally, redirect to login page or handle the missing token case
    // vm.$router.push({ name: 'Login' });
  }

  if (config.headers.showLoading !== false) {
    store.commit('isLoading', true)
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

api.interceptors.response.use((response) => {
  store.commit('isLoading', false)
  return response
}, (error) => {
  // console.log(error.response)
  store.commit('isLoading', false)
  if (error.response && error.response.data.code) {
    const errorCode = error.response.data.code
    switch (errorCode) {
      case 1001:
        console.error('Email or Password error')
        vm.$swal({
          title: 'Login failed',
          text: 'Email or Password error',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 1002:
        console.error('Account expired')
        vm.$swal({
          title: 'Login failed',
          text: 'Account expired, please check with local distributor',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 1003:
        console.error('Please enter your email')
        vm.$swal({
          title: 'Login failed',
          text: 'Please enter your email',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 1004:
        console.error('Please enter your password')
        vm.$swal({
          title: 'Login failed',
          text: 'Please enter your password',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 1101:
        console.error('忘記密碼查無帳號')
        vm.$swal({
          title: '找不到該 E-mail 對應的使用者。',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 1102:
        console.error('Email Error')
        vm.$swal({
          title: 'Please check your email',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 1201:
        console.error('舊密碼錯誤')
        vm.$swal({
          title: '舊密碼錯誤',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 1202:
        console.error('密碼請設置8-20碼英數混合密碼（英文字母需區分大小寫）')
        vm.$swal({
          title: '密碼請設置8-20碼英數混合密碼（英文字母需區分大小寫）',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 1203:
        console.error('舊密碼輸入錯誤')
        vm.$swal({
          title: '舊密碼輸入錯誤',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: 'OK'
        })
        break
      case 3001:
        console.error('logout')
        store.commit('logout')
        vm.$router.push({ name: 'Home' })
        break
      default:
        console.error('Unexpected error:', errorCode)
        vm.swal({
          title: 'Unexpected error',
          icon: 'error',
          confirmButtonText: '返回'
        }).then((isConfirm) => {
          if (isConfirm.value === true) {
            vm.$router.push({ name: 'Home' })
          }
        })
    }
  } else {
    console.error('Network error:', error.message)
  }

  return Promise.reject(error)
})

export default api
